import React from "react";
import "./SharedTextsList.scss";
import { Accordion } from "../Accordion/Accordion";
import { Table } from "../Table/Table";

export function SharedTextsList({ sharedTexts }) {
  return (
    <div className="shared-texts-list-container">
      {sharedTexts.map((item) => {
        return (
          <Accordion
            key={item.title}
            title={item.title}
            lastSharedAt={item.lastSharedAt}
          >
            <Table project={item} attachments={item.attachments} />
          </Accordion>
        );
      })}
    </div>
  );
}
